module.exports = __webpack_public_path__ + "img/5b365e8a95e504c016097d567cd47b47.ead5e0a2.png";